import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]
  static values = { base: String }

  connect() {
    this.update()
  }

  update() {
    const slug = this.inputTarget.value
    if (slug) {
      this.previewTarget.textContent = `${this.baseValue}/funds/${slug}`
      this.previewTarget.classList.remove("hidden")
    } else {
      this.previewTarget.classList.add("hidden")
    }
  }
}
